/* eslint-disable */
import { BrowserRouter, Switch } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import Route from "./router";
import Login from "../screens/auth";
import DashBoard from "../screens/dashboard";
import NewPlace from "../screens/newPlace";
import NavBard from "../components/sideBarCommon";
import { LoginState } from "../store/ducks/auth/types";
import Place from "../screens/place";
import Buffer from "../screens/buffer";
import excelPoliposition from "../screens/excelPoliPosition";
import newPolepositions from "../screens/newPoleposition";
import polepositions from "../screens/polepositions";
import ScheduleReservation from "../screens/scheduleReservation";
import NewScheduleReservation from "../screens/newScheduleReservation";
import AddUser from "../screens/users";
import Discration from "../screens/discrations";
import NewDiscration from "../screens/newDiscrations";
import RankingView from "../screens/rankingView";
import Schedule from "../screens/schedule";
import Enterprises from "../screens/enterprises";
import Criterions from "../screens/discrations/index_new";
import SimpleDiscration from "../screens/newDiscrations/simple";
import Variable from "../screens/newDiscrations/variable";
import EditPolePosition from "../screens/editPoleposition";
import LogUsers from "../screens/logUsers";
import LogUser from "../screens/logUser";

export interface PropsParams {
  Login: {};
}
export default function Router() {
  const { signed } = useSelector<RootStateOrAny, LoginState>(
    (state) => state.user
  );
  return (
    <BrowserRouter>
      {signed && <NavBard />}
      <Switch>
        <Route path="/" exact isPrivate={false} component={Login} />
        <Route path="/menu" isPrivate component={DashBoard} />
        <Route path="/listar-locais" isPrivate component={Place} />
        <Route path="/cadastrar/locais" isPrivate component={NewPlace} />
        <Route path="/buffer" isPrivate component={Buffer} />
        <Route
          path="/importar-planilha-poleposition"
          isPrivate
          component={excelPoliposition}
        />
        <Route path="/polipositions" isPrivate component={polepositions} />
        <Route
          path="/novo-poleposition"
          isPrivate
          component={newPolepositions}
        />
        <Route
          path="/scheduleReservation"
          isPrivate
          component={ScheduleReservation}
        />
        <Route
          path="/newScheduleReservation"
          isPrivate
          component={NewScheduleReservation}
        />
        <Route path="/usuarios" isPrivate component={AddUser} />
        <Route path="/criterios" isPrivate component={Discration} />
        <Route path="/novo-criterio" isPrivate component={NewDiscration} />
        <Route path="/ranking" isPrivate component={RankingView} />
        <Route path="/reservas-de-posicoes" isPrivate component={Schedule} />
        <Route path="/empreendimentos" isPrivate component={Enterprises} />
        <Route
          path="/criterios-poleposition"
          isPrivate
          component={Criterions}
        />
        <Route
          path="/cadastrar-criterio-simples"
          isPrivate
          component={SimpleDiscration}
        />
        <Route
          path="/cadastrar-criterio-variavel"
          isPrivate
          component={Variable}
        />
        <Route
          path="/editar-polepositions"
          isPrivate
          component={EditPolePosition}
        />
        <Route path="/log-usuarios" isPrivate exact component={LogUsers} />
        <Route path="/log-usuarios/:id" isPrivate exact component={LogUser} />
      </Switch>
    </BrowserRouter>
  );
}
